import React from "react";

export enum InfobannerType {
	Info,
	Error,
}

interface InfobannerProps {
	children: React.ReactNode;
	type: InfobannerType;
}
export function Infobanner(props: InfobannerProps) {
	return (
		<div
			className={`
			border rounded px-2 py-1 text-xs
			${props.type === InfobannerType.Info ? "bg-gray-50 border-gray-200" : ""}
			${props.type === InfobannerType.Error ? "bg-red-50 border-red-200 text-red-900" : ""}
			`}
		>
			{props.children}
		</div>
	);
}
